import { defineComponent as _defineComponent } from 'vue'
import TileGridWidgetImageTile from './TileGridWidgetImageTile.vue';
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { TileGridWidgetSplitTile } from 'JS/dxp/types/widgets/tile-grid-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileGridWidgetSplitTile',
  props: {
    splitTile: null,
    promoAttrs: null
  },
  setup(__props: any) {

const props = __props as {
	splitTile: TileGridWidgetSplitTile;
	promoAttrs: AnalyticsPromoAttrs[];
}




return { __sfc: true,props, TileGridWidgetImageTile }
}

})